import type { ImageProps } from "next/image";
import NextImage from "next/image";

export { type ImageProps };
const Image = NextImage;
export default Image;
